import { Stack } from '@mui/material'
import React from 'react'
import { DownloadsSearchResult } from '../../models'
import { ListSkeleton } from '@e3dc-react/shell/Elements/Skeletons'
import DownloadItemNode from '../DownloadItemNode'
import { BlankView, BlankViewImageVariants } from 'src/Components/blank-view'

interface SearchFileViewProps {
  setChosenCategoryId: (id?: number) => void
  files: DownloadsSearchResult[]
  isLoading?: boolean
  isServiceUser?: boolean
  favoriteFileIds: number[]
}

const SearchFileView: React.FC<SearchFileViewProps> = ({ files, setChosenCategoryId, isLoading, isServiceUser, favoriteFileIds }) => {
  if (isLoading) {
    return <ListSkeleton />
  }

  if (files.length === 0) {
    return <BlankView imageVariant={BlankViewImageVariants.Neutral} title={'downloads.search.no-results'} />
  }

  return (
    <Stack direction={'column'} spacing={2} sx={{ mb: 2 }}>
      {files.map(file => {
        return (
          <DownloadItemNode
            key={file.id}
            showBreadcrumbs
            file={file}
            selectCategory={setChosenCategoryId}
            searchResultParents={file.parents}
            isServiceUser={isServiceUser}
            favoriteFileIds={favoriteFileIds}
          />
        )
      })}
    </Stack>
  )
}

export default SearchFileView
